const LOCAL_STORAGE_COMPARE_KEY = 'shopify-compare';
const LOCAL_COMPARE_STORAGE_DELIMITER = ',';
const BUTTON_COMPARE_ACTIVE_CLASS = 'active';
const GRID_COMPARE_LOADED_CLASS = 'loaded';

const compareSelectors = {
  button: '[button-compare]',
  grid: '[grid-compare]',
  productCard: '.product-card-compare',
};

document.addEventListener('DOMContentLoaded', () => {
  var text=document.getElementsByClassName("product-recommendations");
  var len=text.length;	
  if(!len)initButtonsCompare();
  initGridCompare();
});

document.addEventListener('shopify-compare:updated', (event) => {
  console.log('[Shopify Compare] Compare Updated ✅', event.detail.compare);
  initGridCompare();
});

document.addEventListener('shopify-compare:init-product-grid', (event) => {
  console.log('[Shopify Compare] Compare Product List Loaded ✅', event.detail.compare);
});

document.addEventListener('shopify-compare:init-buttons', (event) => {
  console.log('[Shopify Compare] Compare Buttons Loaded ✅', event.detail.compare);
});

const fetchCompareProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(compareSelectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Compare] Failed to load content for handle: ${handle}`, err));
};

const setupGridCompare = async (grid) => {
  const compare = getCompare();
  const requests = compare.map(fetchCompareProductCardHTML);
  const responses = await Promise.all(requests);
  const compareProductCards = responses.join('');
  grid.innerHTML = compareProductCards;
  grid.classList.add(GRID_COMPARE_LOADED_CLASS);
  initButtonsCompare();

  const event = new CustomEvent('shopify-compare:init-product-grid', {
    detail: { compare: compare }
  });
  document.dispatchEvent(event);
};

const setupCompareButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Compare] Missing `data-product-handle` attribute. Failed to update the compare.');
    if (compareContains(productHandle)) button.classList.add(BUTTON_COMPARE_ACTIVE_CLASS);
    button.addEventListener('click', () => {
      updateCompare(productHandle);
      button.classList.toggle(BUTTON_COMPARE_ACTIVE_CLASS);
    });
  });
};

const initGridCompare = () => {
  const grid = document.querySelector(compareSelectors.grid) || false;
  if (grid) setupGridCompare(grid);
};

const initButtonsCompare = () => {
  const buttons = document.querySelectorAll(compareSelectors.button) || [];
  if (buttons.length) setupCompareButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-compare:init-buttons', {
    detail: { compare: getCompare() }
  });
  document.dispatchEvent(event);
};

const getCompare = () => {
  const compare = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY) || false;
  if (compare) return compare.split(LOCAL_COMPARE_STORAGE_DELIMITER);
  return [];
};

const setCompare = (array) => {
  const compare = array.join(LOCAL_COMPARE_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_COMPARE_KEY, compare);
  else localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);

  const event = new CustomEvent('shopify-compare:updated', {
    detail: { compare: array }
  });
  updateCompareCount();    
  document.dispatchEvent(event);

  return compare;
};

const updateCompare = (handle) => {
  const compare = getCompare();
  const indexInCompare = compare.indexOf(handle);
  if (indexInCompare === -1) compare.push(handle);
  else compare.splice(indexInCompare, 1);
  return setCompare(compare);
};

const compareContains = (handle) => {
  const compare = getCompare();
  return compare.includes(handle);
};

const resetCompare = () => {
  return setCompare([]);
};

const updateCompareCount = () => {
    const compare = getCompare();       
    $('[data-js-compare-count]').attr('data-js-compare-count', compare.length).html(compare.length);
    if (compare.length==0){
      $(".comp-info").css("display", "block");
    }
    else{
      $(".comp-info").css("display", "none");
    }     
};

$(document).ready(function() {
  updateCompareCount();
})

document.addEventListener('shopify-compare:init-product-grid', function () {

  const grid = document.querySelector('[grid-compare]');
  const products = grid.querySelectorAll('.product-card-compare');
  if (!products.length) return;

  let items = [];

  products.forEach(p => {
    items.push({
      handle: p.dataset.handle,
      title: p.dataset.title,
      image: p.dataset.image,
      price: p.dataset.price,
      rawPrice: parseInt(p.dataset.priceRaw),
      vendor: p.dataset.vendor,
      type: p.dataset.type,
      sku: p.dataset.sku,
      availability: p.dataset.availability,
      viscosity: p.dataset.viscosity,
      api: p.dataset.api,
      description: p.dataset.description,
      variantId: p.dataset.variantId
    });
  });

  const cheapestPrice = Math.min(...items.map(i => i.rawPrice));

  const specs = [
    { key: 'price', label: 'Price' },
    { key: 'vendor', label: 'Brand' },
    { key: 'type', label: 'Type' },
    { key: 'sku', label: 'SKU' },
    { key: 'availability', label: 'Availability' },
    { key: 'viscosity', label: 'Viscosity' },
    { key: 'api', label: 'API' },
    { key: 'description', label: 'Description' }
  ];

  let table = `
  <div class="compare-wrapper">
    <div class="compare-controls">
      <label>
        <input type="checkbox" id="toggle-diff">
        Highlight Differences
      </label>
    </div>

    <div class="compare-scroll">
    <table class="amazon-compare">
      <thead>
        <tr>
          <th class="feature-column"></th>
  `;

  items.forEach(item => {

    table += `
      <th class="${item.rawPrice === cheapestPrice ? 'best-price' : ''}">
        <img src="${item.image}" />
        <div class="compare-title">${item.title}</div>
        <div class="compare-price">${item.price}</div>
        ${item.rawPrice === cheapestPrice ? '<div class="badge best">Best Price</div>' : ''}
        <div class="compare-header-buttons">
          <button class="remove-product" data-handle="${item.handle}">Remove</button>
          <button class="add-to-cart" data-id="${item.variantId}">Add to Cart</button>
        </div>
      </th>
    `;
  });

  table += `</tr></thead><tbody>`;

  specs.forEach(spec => {

    const values = items.map(item => item[spec.key]);
    const allEmpty = values.every(val => !val || val === '');

    if (!allEmpty) {

      table += `<tr data-spec="${spec.key}">
        <td class="feature-column">${spec.label}</td>`;

      values.forEach(val => {

  if (!val || val === '') {
    table += `<td>-</td>`;
  } else if (spec.key === 'description') {

  const shortText = val.length > 120 ? val.substring(0,120) + '...' : val;

  table += `
    <td>
      <div class="desc-container">
        <div class="desc-content collapsed">
          ${val}
        </div>
        ${val.length > 120 ? `
          <button class="read-more-btn">Read More</button>
        ` : ''}
      </div>
    </td>
  `;
}
 else {
    table += `<td>${val}</td>`;
  }

});


      table += `</tr>`;
    }
  });

  table += `</tbody></table></div></div>`;

  grid.innerHTML = table;

  /* REMOVE */
  document.querySelectorAll('.remove-product').forEach(btn => {
    btn.addEventListener('click', function () {
      updateCompare(this.dataset.handle);
    });
  });

  /* ADD TO CART */
  document.querySelectorAll('.add-to-cart').forEach(btn => {
    btn.addEventListener('click', function () {

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.dataset.id,
          quantity: 1
        })
      })
      .then(res => res.json())
      .then(() => {
        window.location.href = '/cart';
      });
    });
  });

  /* HIGHLIGHT */
  document.getElementById('toggle-diff').addEventListener('change', function () {

    document.querySelectorAll('.amazon-compare tbody tr').forEach(row => {

      const cells = Array.from(row.querySelectorAll('td')).slice(1);
      const values = cells.map(td => td.textContent.trim());
      const unique = [...new Set(values)];

      if (unique.length > 1) {
        row.classList.toggle('highlight-row', this.checked);
      }
    });
  });

});
/* SMOOTH READ MORE */
document.addEventListener('click', function(e) {

  if (e.target.classList.contains('read-more-btn')) {

    const container = e.target.closest('.desc-container');
    const content = container.querySelector('.desc-content');

    content.classList.toggle('expanded');
    content.classList.toggle('collapsed');

    if (content.classList.contains('expanded')) {
      e.target.textContent = 'Read Less';
    } else {
      e.target.textContent = 'Read More';
    }
  }

});
